export default function Logo({ light = false, compact = false }) {
    const wordColor = light ? "text-cream" : "text-forest";
    const subColor = light ? "text-coral-soft" : "text-coral";
    return (
        <span className="flex items-center gap-2.5" aria-label="Mimo & Pata — Pet Shop & Care">
            <span
                className={`grid h-10 w-10 shrink-0 place-items-center rounded-2xl ${light ? "bg-cream/10" : "bg-forest"} transition-colors duration-300`}
            >
                <svg viewBox="0 0 64 64" className="h-6 w-6" fill="none" aria-hidden="true">
                    <g fill={light ? "#F8F5EE" : "#F8F5EE"}>
                        <ellipse cx="20.5" cy="26" rx="5.2" ry="7" transform="rotate(-18 20.5 26)" />
                        <ellipse cx="32" cy="20.5" rx="5.2" ry="7.4" />
                        <ellipse cx="43.5" cy="26" rx="5.2" ry="7" transform="rotate(18 43.5 26)" />
                    </g>
                    <path
                        d="M32 55c-8-6.2-14.6-11.3-14.6-18.3 0-4.3 3.4-7.7 7.7-7.7 2.8 0 5.4 1.5 6.9 3.8 1.5-2.3 4.1-3.8 6.9-3.8 4.3 0 7.7 3.4 7.7 7.7C46.6 43.7 40 48.8 32 55z"
                        fill="#EE957E"
                    />
                </svg>
            </span>
            {!compact && (
                <span className="flex flex-col leading-none">
                    <span className={`font-serif text-lg font-bold tracking-tight ${wordColor}`}>
                        Mimo <span className="text-coral">&amp;</span> Pata
                    </span>
                    <span className={`text-[9px] font-bold uppercase tracking-[0.32em] ${subColor}`}>
                        Pet Shop &amp; Care
                    </span>
                </span>
            )}
        </span>
    );
}
